import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { AlertTriangle, X } from "lucide-react";
import { Button } from "@/components/ui";
export const DeleteUserModal = ({ isOpen, user, onClose, onConfirm, isLoading })=>{
    const [isDeleting, setIsDeleting] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(null);
    const handleConfirm = async ()=>{
        if (!user) return;
        setIsDeleting(true);
        setErrorMessage(null);
        try {
            await onConfirm(user.UserId);
            onClose();
        } catch (error) {
            const fallbackMessage = "Failed to remove user";
            setErrorMessage(error instanceof Error ? error.message : fallbackMessage);
        } finally{
            setIsDeleting(false);
        }
    };
    if (!isOpen || !user) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: "fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50",
        children: /*#__PURE__*/ _jsx("div", {
            className: "relative top-1/2 transform -translate-y-1/2 mx-auto p-5 border w-full max-w-md shadow-lg rounded-md bg-white",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center justify-between mb-4",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex-shrink-0",
                                        children: /*#__PURE__*/ _jsx(AlertTriangle, {
                                            className: "h-6 w-6 text-red-600"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "ml-2 text-lg font-medium text-gray-900",
                                        children: "Remove User"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("button", {
                                onClick: onClose,
                                className: "text-gray-400 hover:text-gray-600",
                                disabled: isLoading || isDeleting,
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "sr-only",
                                        children: "Close"
                                    }),
                                    /*#__PURE__*/ _jsx(X, {
                                        className: "h-6 w-6"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mb-6",
                        children: /*#__PURE__*/ _jsxs("p", {
                            className: "text-sm text-gray-600",
                            children: [
                                "Are you sure you want to remove ",
                                /*#__PURE__*/ _jsx("strong", {
                                    children: user.FullName
                                }),
                                " (",
                                user.Email,
                                ") from the organization? This action cannot be undone."
                            ]
                        })
                    }),
                    errorMessage && /*#__PURE__*/ _jsx("p", {
                        className: "mb-4 text-sm text-red-600",
                        children: errorMessage
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex justify-end space-x-3",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                variant: "simple",
                                buttonStyle: "flat",
                                onClick: onClose,
                                disabled: isLoading || isDeleting,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                type: "button",
                                className: "px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed",
                                onClick: handleConfirm,
                                disabled: isLoading || isDeleting,
                                children: isLoading || isDeleting ? "Removing..." : "Remove User"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
